import { AlertContext } from "context/alert-context";
import { useContext } from "react";

export const useAlert = () => {
  return useContext(AlertContext);
};